/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoteSsoStartRequest
 */
export interface RemoteSsoStartRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoteSsoStartRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RemoteSsoStartRequest
     */
    plan: string;
    /**
     * 
     * @type {object}
     * @memberof RemoteSsoStartRequest
     */
    userInfo: object;
    /**
     * 
     * @type {string}
     * @memberof RemoteSsoStartRequest
     */
    provider?: string;
}

/**
 * Check if a given object implements the RemoteSsoStartRequest interface.
 */
export function instanceOfRemoteSsoStartRequest(value: object): value is RemoteSsoStartRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('userInfo' in value) || value['userInfo'] === undefined) return false;
    return true;
}

export function RemoteSsoStartRequestFromJSON(json: any): RemoteSsoStartRequest {
    return RemoteSsoStartRequestFromJSONTyped(json, false);
}

export function RemoteSsoStartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoteSsoStartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'plan': json['plan'],
        'userInfo': json['userInfo'],
        'provider': json['provider'] == null ? undefined : json['provider'],
    };
}

export function RemoteSsoStartRequestToJSON(json: any): RemoteSsoStartRequest {
    return RemoteSsoStartRequestToJSONTyped(json, false);
}

export function RemoteSsoStartRequestToJSONTyped(value?: RemoteSsoStartRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'plan': value['plan'],
        'userInfo': value['userInfo'],
        'provider': value['provider'],
    };
}

